/* eslint-disable prefer-promise-reject-errors */
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Form,
  Input,
  message,
  Spin,
  Tooltip,
  Typography
} from 'antd';
import jwt from 'jsonwebtoken';
import React, { useContext, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { CONFIG, USER_STATES } from '../constants';
import EmpresaContext from '../context/empresa-context';
import UserContext from '../context/user-context';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';

const { Title } = Typography;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOGIN;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { updateUser, updateAccessToken, user, userState } = useContext(
    UserContext
  );
  const [newPasswordRequired, setNewPasswordRequired] = useState(false);
  const { empresa } = useContext(EmpresaContext);
  const history = useHistory();
  const onFinish = (values) => {
    setLoading(true);
    const { username, password, newPassword } = values;

    const data = {
      username,
      password,
      newPassword
    };

    // Encriptar datos de login con JWT
    const userData = jwt.sign(data, secretKey);

    instanceRef.instance
      .post('auth/login', { userData })
      .then((response) => {
        setLoading(false);
        if (response?.data?.data) {
          if (response?.data?.data === 'NewPasswordRequired') {
            setNewPasswordRequired(true);
          } else {
            const { accessToken, idToken, usuarioSegu } = response.data.data;
            updateAccessToken(accessToken.jwtToken);
            instanceRef.instance.defaults.headers.common.Authorization = `Bearer ${accessToken.jwtToken}`;
            updateUser({ ...idToken.payload, usuarioSegu });
            history.push('/');
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data?.message?.code === 'NotAuthorizedException') {
          message.error('Nombre de usuario o contraseña incorrectos');
        } else {
          errorHandler(error);
        }
      });
  };

  const styles = {
    container: {
      backgroundColor: CONFIG.COLOR_PRIMARY,
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    card: {
      width: 320,
      borderRadius: 20,
      boxShadow: '0 11px 34px 0 rgba(0,0,0,.8)'
    }
  };

  if (userState === USER_STATES.loggingStart) {
    return <Spin spinning className="spin-radius" tip="Cargando..." />;
  }

  if (!user || userState === USER_STATES.notLogged) {
    return (
      <div style={styles.container}>
        <Spin spinning={loading} delay={500} className="spin-radius">
          <Card style={styles.card}>
            <Form
              layout="vertical"
              name="login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              size="small"
            >
              {empresa && (
                <table
                  justify="start"
                  align="middle"
                  style={{
                    width: '100%'
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          verticalAlign: 'top',
                          width: '200px',
                          objectFit: 'contain'
                        }}
                      >
                        <img
                          src={`/images/empresas/${empresa.codigo}.png`}
                          alt="imagen empresa"
                          width="100%"
                          style={{
                            verticalAlign: 'top',
                            maxHeight: '200px',
                            maxWidth: '200ox',
                            objectFit: 'contain'
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
              <Title level={4}>Iniciar sesión</Title>
              <br />
              <Form.Item
                label="Usuario"
                name="username"
                rules={[{ required: true, message: 'Campo requerido!' }]}
              >
                <Input
                  readOnly={newPasswordRequired}
                  placeholder="Ingrese su Nombre de Usuario"
                />
              </Form.Item>

              <Form.Item
                label="Contraseña"
                name="password"
                rules={[{ required: true, message: 'Campo requerido!' }]}
              >
                <Input.Password
                  readOnly={newPasswordRequired}
                  placeholder="Ingrese su contraseña"
                />
              </Form.Item>
              {newPasswordRequired && (
                <>
                  <Form.Item
                    label={
                      <span>
                        Nueva Contraseña&nbsp;
                        <Tooltip
                          title={
                            <span>
                              Entre 8 y 99 caractares
                              <br />
                              Al menos una minúscula
                              <br />
                              Al menos una mayúscula
                              <br />
                              Al menos un número
                              <br />
                            </span>
                          }
                        >
                          <QuestionCircleOutlined />
                        </Tooltip>
                      </span>
                    }
                    name="newPassword"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Contraseña es un campo requerido'
                      },
                      () => ({
                        validator(_, value) {
                          const longitud = value?.length || 0;
                          const tieneMinuscula = /(?=.*[a-z])/.test(value);
                          const tieneMayuscula = /(?=.*[A-Z])/.test(value);
                          const tieneNumero = /(?=.*[0-9])/.test(value);
                          // eslint-disable-next-line no-useless-escape
                          // eslint-disable-next-line no-useless-escape
                          const valid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}$/.test(
                            value
                          );

                          if (longitud <= 0) {
                            return Promise.resolve();
                          }

                          if (!tieneMinuscula) {
                            return Promise.reject(
                              'La contraseña debe contener alguna letra minúscula'
                            );
                          }

                          if (!tieneMayuscula) {
                            return Promise.reject(
                              'La contraseña debe contener alguna letra mayúscula'
                            );
                          }

                          if (!tieneNumero) {
                            return Promise.reject(
                              'La contraseña debe contener algún número'
                            );
                          }

                          if (longitud < 8) {
                            return Promise.reject(
                              'La longitud mínima es de 8 caracteres'
                            );
                          }

                          if (longitud > 99) {
                            return Promise.reject(
                              'La longitud máxima es de 99 caracteres'
                            );
                          }

                          if (valid) {
                            return Promise.resolve();
                          }
                          return Promise.reject('Revisar contraseña');
                        }
                      })
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      placeholder="Nueva contraseña"
                    />
                  </Form.Item>
                  <Form.Item
                    name="confirmNewPassword"
                    label="Confirmar nueva contraseña"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Por favor confirme su contraseña!'
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue('newPassword') === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            'Las dos contraseñas que ingresaste no son iguales'
                          );
                        }
                      })
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>
                </>
              )}
              <Form.Item>
                <div style={{ textAlign: 'center' }}>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    style={{ marginTop: 20 }}
                  >
                    Iniciar sesión
                  </Button>
                  {!newPasswordRequired && (
                    <NavLink to="/recuperar">
                      <Button
                        type="link"
                        htmlType="button"
                        style={{ marginTop: 20 }}
                      >
                        Olvidé mi contraseña
                      </Button>
                    </NavLink>
                  )}
                </div>
              </Form.Item>
            </Form>
          </Card>
        </Spin>
      </div>
    );
  }

  return <Redirect to="/" />;
};

export default Login;
